import EnrolmentFormStage from "@/components/course-progress/stages/EnrolmentFormStage";

export default function OnlineEnrolmentNew(props) {
  return <EnrolmentFormStage mode={props.isAdminReview ? "admin" : "student"} {...props} />;
}
